import { assertNever, noop } from '@kofno/piper';
import { action, makeObservable, observable } from 'mobx';
import { error } from '../../../../../../../ErrorHandling';
import { TPlainTextKey } from '../../../../../../../Translations';
import { ImportedParticipantsResource, SuccessfulParticipant } from '../../../../Store/Types';
import { ExtendedGroupOption } from '../GroupFormState/GroupForm/GroupDynamicTypeaheadSelect/UseGroupDynamicTypeaheadSelect/Types';
import {
  AddParticipantsToGroupFormState,
  ready,
  removeParticipant,
  setGroup,
  submit,
  success,
  unsetGroup,
} from './Types';

export class AddParticipantsToGroupFormStore {
  @observable
  state: AddParticipantsToGroupFormState;

  constructor(
    participants: SuccessfulParticipant[],
    importedParticipantsResource: ImportedParticipantsResource,
  ) {
    makeObservable(this);
    this.state = ready(participants, importedParticipantsResource);
  }

  @action
  setGroup = (group: ExtendedGroupOption<string>) => {
    switch (this.state.kind) {
      case 'ready':
        this.state = setGroup(group, this.state);
        break;
      case 'ready-to-submit':
      case 'submitting':
      case 'success':
      case 'error':
        break;
      default:
        assertNever(this.state);
    }
  };

  @action
  removeParticipant = (participant: SuccessfulParticipant) => {
    switch (this.state.kind) {
      case 'ready':
      case 'ready-to-submit':
        switch (this.state.participants.length) {
          case 1:
            noop;
            break;
          default:
            this.state = removeParticipant(participant, this.state);
            break;
        }
        break;
      case 'submitting':
      case 'success':
      case 'error':
        break;
      default:
        assertNever(this.state);
    }
  };

  @action
  unsetGroup = () => {
    switch (this.state.kind) {
      case 'ready':
        break;
      case 'ready-to-submit':
        this.state = unsetGroup(this.state);
        break;
      case 'submitting':
      case 'success':
      case 'error':
        break;
      default:
        assertNever(this.state);
    }
  };

  @action
  submit = () => {
    switch (this.state.kind) {
      case 'ready':
        break;
      case 'ready-to-submit':
        this.state = submit(this.state);
        break;
      case 'submitting':
      case 'success':
      case 'error':
        break;
      default:
        assertNever(this.state);
    }
  };

  @action
  success = () => {
    switch (this.state.kind) {
      case 'submitting':
        this.state = success(this.state);
        break;
      case 'ready':
      case 'ready-to-submit':
      case 'success':
      case 'error':
        break;
      default:
        assertNever(this.state);
    }
  };

  @action
  error = (msg: TPlainTextKey) => {
    this.state = error(msg);
  };
}

export default AddParticipantsToGroupFormStore;
